import { useTranslation } from 'react-i18next';

import { Can } from 'components/Can';
import ResearchKpiGroupViewList from 'features/ResearchKpiGroup';

import Layout from 'layout';
import { LayoutProvider } from 'layout/context/layoutcontext';

function ResearchKpiGroupViewListPage() {
  const { t } = useTranslation();
  return (
    <LayoutProvider>
      <Layout>
        <>
          <Can do="read" on="research_kpi_group">
            <ResearchKpiGroupViewList />
          </Can>
          <Can not do="read" on="research_kpi_group">
            <h4 className="text-red-500">{t('permission.forbid.read.researchKpiGroupList')}</h4>
          </Can>
        </>
      </Layout>
    </LayoutProvider>
  );
}

export default ResearchKpiGroupViewListPage;
